export default __webpack_public_path__ + "static/media/2014.139891ad.png";